import { SVGS } from '@zonofi/zono-money-design-system';
import React, { RefObject } from 'react';

interface ImgType {
  src: string;
  [key: string]: any;
}

interface MasonryProps {
  imgs: ImgType[];
  selected: string[];
  handleToggleSelect: (src: string) => void;
  selectedImageContainerRefs: RefObject<Map<string, HTMLDivElement>>;
  styles: {
    readonly [key: string]: string;
  };
}

export const Masonry: React.FC<MasonryProps> = ({
  imgs,
  selected,
  handleToggleSelect,
  selectedImageContainerRefs,
  styles,
}) => (
  <div className={styles.masonry} role="list">
    {imgs.map((img) => {
      const isSelected = selected.includes(img.src);
      return (
        <div key={img.src} className={styles.masonryItem} role="listitem">
          <div
            ref={(el) => {
              if (el && isSelected) {
                selectedImageContainerRefs.current?.set(img.src, el);
              } else if (!isSelected) {
                selectedImageContainerRefs.current?.delete(img.src);
              }
            }}
            className={styles.tile}
            aria-selected={isSelected}
            onClick={() => handleToggleSelect(img.src)}
          >
            <img src={img.src} alt="image" loading="lazy" />
            <button
              type="button"
              aria-pressed={isSelected}
              aria-label={isSelected ? 'Deselect' : 'Select'}
              className={`${styles.customSelectBtn} ${isSelected ? styles.customSelectBtnSelected : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                handleToggleSelect(img.src);
              }}
            >
              <img
                src={isSelected ? SVGS.CheckBoxTick : SVGS.CheckBoxUnTick}
                alt="check"
                className={styles.customSelectIcon}
              />
            </button>
          </div>
        </div>
      );
    })}
  </div>
);

export default Masonry;
